import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { TaxationTypeEnum } from '@zaoblako/shared/modules/catalog/enums/taxation-type.enum';
import { JurisdictionTypeEnum } from '@zaoblako/shared/modules/client/enums/jurisdiction-type.enum';
import { type PersonFindInterface, PersonFindDto } from '@zaoblako/shared/modules/client/dtos/person/person-find.dto';
import { type Connection1cFindInterface, Connection1cFindDto } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { type BankDetailsFindInterface, BankDetailsFindDto } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-find.dto';
import { type CurrencyFindInterface, CurrencyFindDto } from '@zaoblako/shared/modules/catalog/dtos/currency/currency-find.dto';
import { type FileFindInterface, FileFindDto } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import type { CompanyGroupFindInterface } from '@zaoblako/shared/modules/client/dtos/company.group/company-group-find.dto';

import * as yup from 'yup';

export interface CompanyFindInterface extends PersonFindInterface {
  connection: Connection1cFindInterface;
  stamp?: FileFindInterface;
  signature?: FileFindInterface;
  taxationType?: TaxationTypeEnum;
  jurisdiction?: JurisdictionTypeEnum;
  group?: CompanyGroupFindInterface;
  allDocumentTypesAllowed?: boolean;
  bankDetails: BankDetailsFindInterface[];
  currencies: CurrencyFindInterface[];
  modulbankApiKey?: string;
  alfabankApiKey?: string;
  tbankApiKey?: string;
  tochkabankApiKey?: string;
}

export const CompanyFindDto = SerdeDtoClass.from<PersonFindInterface, CompanyFindInterface>(
  PersonFindDto,
  ClientDtoKeysEnum.COMPANY_FIND_DTO,
  {
    connection: {
      label: 'Соединение',
      nested: Connection1cFindDto,
      serializer: (_, nested) => nested,
    },
    stamp: {
      optional: true,
      label: 'Печать',
      nested: FileFindDto,
      serializer: (_, nested) => nested,
    },
    signature: {
      optional: true,
      label: 'Подпись',
      nested: FileFindDto,
      serializer: (_, nested) => nested,
    },
    taxationType: {
      optional: true,
      label: 'Тип налогообложения',
      serializer: yup
        .string()
        .oneOf(Object.values(TaxationTypeEnum)),
    },
    jurisdiction: {
      optional: true,
      sortable: true,
      label: 'Юрисдикция',
      serializer: yup
        .string()
        .oneOf(Object.values(JurisdictionTypeEnum)),
    },
    group: {
      optional: true,
      label: 'Группа',
      nested: ClientDtoKeysEnum.COMPANY_GROUP_FIND_DTO,
      serializer: (_, nested) => nested,
    },
    allDocumentTypesAllowed: {
      optional: true,
      sortable: true,
      label: 'Изменение всех типов документов',
      serializer: yup.boolean(),
    },
    bankDetails: {
      label: 'Реквизиты',
      nested: BankDetailsFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
    currencies: {
      label: 'Валюты',
      nested: CurrencyFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
    modulbankApiKey: {
      optional: true,
      label: 'API ключ Modulbank',
      serializer: yup.string(),
    },
    alfabankApiKey: {
      optional: true,
      label: 'API ключ Alfabank',
      serializer: yup.string(),
    },
    tbankApiKey: {
      optional: true,
      label: 'API ключ Tbank',
      serializer: yup.string(),
    },
    tochkabankApiKey: {
      optional: true,
      label: 'API ключ Точка Банк',
      serializer: yup.string(),
    },
  },
);
